import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api.js'
import { VERSION_BUNDLE } from '../lib/version-cliente.js'

/**
 * Versión desplegada, abajo a la derecha. Para auditoría: responde a «¿estoy mirando la
 * versión que creo?» sin abrir una terminal.
 */
export function VersionTag() {
  const q = useQuery({ queryKey: ['version'], queryFn: api.version, staleTime: Infinity, retry: false })
  if (!q.data) return null

  const { version, shortCommit, branch, dirty, dirtyFiles, untrackedFiles, builtAt, startedAt } = q.data
  const fecha = (iso) => (iso ? new Date(iso).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' }) : '—')

  const desfasado = VERSION_BUNDLE?.version && VERSION_BUNDLE.version !== version
  return (
    <div className="version-tag" title={[
      `Servidor: v${version}`,
      VERSION_BUNDLE?.version
        ? `Bundle cargado: v${VERSION_BUNDLE.version} (${VERSION_BUNDLE.shortCommit ?? 'sin commit'})${desfasado ? ' ⚠ DESFASADO: recarga' : ''}`
        : 'Bundle cargado: sin versión horneada (dev)',
      shortCommit && `Commit ${shortCommit}${branch ? ` (${branch})` : ''}`,
      dirty && `Construido con cambios sin confirmar en:\n  ${(dirtyFiles ?? ['(sin detalle)']).join('\n  ')}`,
      untrackedFiles?.length && `Ficheros no rastreados en el contexto (no afectan al commit):\n  ${untrackedFiles.join('\n  ')}`,
      `Construido: ${fecha(builtAt)}`,
      `Arrancado: ${fecha(startedAt)}`,
    ].filter(Boolean).join('\n')}>
      v{version}
      {shortCommit && <span className="sep">·</span>}
      {shortCommit && <span className="mono">{shortCommit}</span>}
      {dirty && <span className="dirty">sucio</span>}
      {desfasado && <span className="dirty" title="El navegador ejecuta un bundle antiguo: recarga">desfasado</span>}
    </div>
  )
}
